import { common } from '@mui/material/colors';
import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/news-room',
    filterList: (filter) => `/api/news-room?${filter}`,
    listNews: '/api/posts',
    filterListNews: (filter) => `/api/posts?${filter}`,
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  projectListing: {
    list: '/api/project-listings',
    filterList: (filter) => `/api/project-listings?${filter}`,
    filterHeroList: (filter) => `/api/project?${filter}`,
  },
  tags: {
    list: '/api/tags',
    filterList: (filter) => `/api/tags?${filter}`,
  },
  homepage: {
    list: '/api/homepage',
    filterList: (filter) => `/api/homepage?${filter}`,
  },
  contactUs: {
    list: '/api/contact-us',
    filterList: (filter) => `/api/contact-us?${filter}`,
  },
  investorLounge: {
    list: '/api/investor-lounge',
    filterList: (filter) => `/api/investor-lounge?${filter}`,
  },
  career: {
    list: '/api/career',
    filterList: (filter) => `/api/career?${filter}`,
  },
  csr: {
    list: '/api/csr',
    filterList: (filter) => `/api/csr?${filter}`,
  },
  about: {
    list: '/api/about-us',
    filterList: (filter) => `/api/about-us?${filter}`,
  },
  common: {
    list: '/api/common',
    filterList: (filter) => `/api/common-component?${filter}`,
  },
};
